<div class="modal-header">
  <h4 class="modal-title">{{ "orders.recent_order_modal_title" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="recentOrderLoader"></myp-inline-loader>
  Your order is being processed and your software license is being set up. Hang tight for just a couple minutes, then refresh this page to see your new product!
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close(false)">Close</button>
</div>
